const EventEmitter = require('events');
const emitter = new EventEmitter()
export default emitter;
